import styled from 'styled-components';

export const VerticalSeparator = styled.div`
  width: 0px;
  border: 1px solid #2e2e2e;
`;

export const HorizontalSeparator = styled.div`
  height: 0.5px;
  background-color: var(--dark-text-color);
  width: 100%;
`;

export const HorizontalSeparatorGray = styled.div`
  height: 0.5px;
  background-color: var(--gray-text-color);
  width: 100%;
`;
